
  <div id="map-wrapper-checker" class="mat-elevation-z8">
  </div>

  
  <span class="mobile-filter">
    <app-lookup [lookupData]="routeLookupData" [appearance]="'fill'" (onChange)="routeChanged($event)"></app-lookup>
  </span>